exports.connect = {
	url: "https://api.parcdufaillal.camp/"
}
